module.exports = __webpack_public_path__ + "static/media/Brochure.1f7a4c9e.png";